<polpo-legals-hero></polpo-legals-hero>

<div class="[ container p-be-3xl stack ]">
  @if (slug$ | async; as slug) {
    @if (slug === 'privacy') {
      <polpo-legals-page-privacy></polpo-legals-page-privacy>
    }
    @if (slug === 'verkoopsvoorwaarden') {
      <polpo-legals-page-sales-conditions></polpo-legals-page-sales-conditions>
    }
    @if (slug === 'gebruiksvoorwaarden') {
      <polpo-legals-page-terms-of-use></polpo-legals-page-terms-of-use>
    }
    @if (slug === 'ai') {
      <polpo-legals-page-ai></polpo-legals-page-ai>
    }
  }
</div>
